import { Component, Input } from "@angular/core";
import { ContractDetails } from "../../models/contractDetails";

@Component({
  standalone: false,
  selector: "app-token-details",
  templateUrl: "./token-details.component.html",
  styleUrls: ["./token-details.component.scss"],
})
export class TokenDetailsComponent {
  @Input()
  tokenDetails: ContractDetails = new ContractDetails();
}
